import React, { useEffect, useState, useContext } from "react";
import Loading from "./Shared/Loading";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import useMediaQuery from '@mui/material/useMediaQuery';

import Filter1Icon from '@mui/icons-material/Filter1';
import Filter2Icon from '@mui/icons-material/Filter2';
import Filter3Icon from '@mui/icons-material/Filter3';
import Filter4Icon from '@mui/icons-material/Filter4';
import Filter5Icon from '@mui/icons-material/Filter5';
import Filter6Icon from '@mui/icons-material/Filter6';
import Filter7Icon from '@mui/icons-material/Filter7';
import Filter8Icon from '@mui/icons-material/Filter8';
import Filter9Icon from '@mui/icons-material/Filter9';

import Grid from '@mui/material/Grid';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

import "./NavMenu.css";

import ModelContext from "./ModelContext";


export const NavMenu = (props) => {
    const [isLoading, setIsLoading] = useState(false);
    const [isOpen, setIsOpen] = useState(false);

    const [inputModelData, setInputModelData] = useState({
        idBasicModel: 0,
        idModel: 0,
        region: "",
        cultureCode: "",
        workingFolder: ""
    });

    const isMobile = useMediaQuery('(max-width:480px)');
    const modelCtx = useContext(ModelContext);

    useEffect(() => {

        const basicModelId = props.basicModelId;
        const currentCultureCode = "en-us";

        const getModels = async () => {
            setIsLoading(true);
            const response = await fetch("/api/model/models/" + basicModelId + "/" + currentCultureCode);

            if (response.ok) {
                const data = await response.json();
                if (data) {
                    modelCtx.updateModelsData(data);
                    setInputModelData({ ...inputModelData, idBasicModel: data[0].idbasicModel, idModel: data[0].idModel, region: "emea", cultureCode: currentCultureCode, workingFolder: data[0].workingFolder });
                    modelCtx.updateInputModelData({ idBasicModel: data[0].idbasicModel, idModel: data[0].idModel, region: "emea", cultureCode: currentCultureCode, workingFolder: data[0].workingFolder });

                } else {
                    //props.feedbackCallback("error", "Errore", true);
                }
            } else {
                const error = await response.text();
                //props.feedbackCallback("error", error, true);
            }
            setIsLoading(false);
        };

        getModels();
    }, []);



    const toggleDrawer = (open) => (event) => {
        if (
            event &&
            event.type === 'keydown' &&
            (event.key === 'Tab' || event.key === 'Shift')
        ) {
            return;
        }

        setIsOpen(open);
    };

    const drawerWidth = 240;

    const setOffsetTop = () => {
        let offset = 80;
        if (isMobile) {
            offset = 50;
        }
        return offset;
    };


    const handleClick = (anchorTag) => (event) => {

        const element = document.getElementById(anchorTag.replace("#", ""));

        setTimeout(() => {
            window.scrollTo({
                behavior: element ? "smooth" : "auto",
                top: element ? element.offsetTop - setOffsetTop() : 0
            });
        }, 100);
    };


    const menuList = () => {
        return (
            <Box
                sx={{ width: drawerWidth }}
                role="presentation"
                onClick={toggleDrawer(false)}
                onKeyDown={toggleDrawer(false)}
            >
                <List>
                    <ListItem key="Intro" disablePadding>
                        <ListItemButton onClick={handleClick("#dream")}>
                            <ListItemIcon>
                                <Filter1Icon />
                            </ListItemIcon>
                            <ListItemText primary="An Aluminium Dream" />
                        </ListItemButton>
                    </ListItem>
                    <Divider />
                    <ListItem key="Exteriors" disablePadding>
                        <ListItemButton onClick={handleClick("#exteriors")}>
                            <ListItemIcon>
                                <Filter2Icon />
                            </ListItemIcon>
                            <ListItemText primary="Exteriors" />
                        </ListItemButton>
                    </ListItem>
                    <Divider />
                    <ListItem key="Interiors" disablePadding>
                        <ListItemButton onClick={handleClick("#interiors")}>
                            <ListItemIcon>
                                <Filter3Icon />
                            </ListItemIcon>
                            <ListItemText primary="Interiors" />
                        </ListItemButton>
                    </ListItem>
                    <Divider />
                    <ListItem key="Video" disablePadding>
                        <ListItemButton onClick={handleClick("#video")}>
                            <ListItemIcon>
                                <Filter4Icon />
                            </ListItemIcon>
                            <ListItemText primary="Video" />
                        </ListItemButton>
                    </ListItem>
                    <Divider />
                    <ListItem key="VirtualTour" disablePadding>
                        <ListItemButton onClick={handleClick("#vt")}>
                            <ListItemIcon>
                                <Filter5Icon />
                            </ListItemIcon>
                            <ListItemText primary="Virtual Tour" />
                        </ListItemButton>
                    </ListItem>
                    <Divider />
                    <ListItem key="Layout" disablePadding>
                        <ListItemButton onClick={handleClick("#arrangements")}>
                            <ListItemIcon>
                                <Filter6Icon />
                            </ListItemIcon>
                            <ListItemText primary="General arrangements" />
                        </ListItemButton>
                    </ListItem>
                    <Divider />
                    <ListItem key="Technical data" disablePadding>
                        <ListItemButton onClick={handleClick("#techdata")}>
                            <ListItemIcon>
                                <Filter7Icon />
                            </ListItemIcon>
                            <ListItemText primary="Technical data" />
                        </ListItemButton>
                    </ListItem>
                    <Divider />
                </List>
            </Box>
        );
    };

    return (
        <>
            {isLoading && <Loading />}
            {!isLoading &&
                <AppBar
                    position="fixed"
                    sx={{ backgroundColor: "#89755D" }}

                >
                    <Toolbar>
                        <IconButton
                            size="large"
                            edge="start"
                            color="inherit"
                            aria-label="menu"
                            sx={{ mr: 2 }}
                            onClick={toggleDrawer(true)}
                        >
                            {!isOpen && <MenuIcon />}
                            {isOpen && <MenuOpenIcon />}
                        </IconButton>

                        <Grid container spacing={0} align="center" justify="center" direction="row">
                            <Grid item xs={12} sm={12} md={4} sx={{ flexGrow: 1, display: { xs: 'none', sm: 'none', md: 'block' }, textAlign: 'left' }}>
                                <img src={"logo/" + inputModelData.workingFolder + "/logo.png"} alt="Logo imbarcazione" />
                            </Grid>
                            <Grid item xs={6} sm={6} md={4} sx={{ flexGrow: 1, display: { xs: 'block', sm: 'block' }, textAlign: { xs: 'center', sm: 'center' }, verticalAlign: 'middle' }}>
                                <div className="box-titleModel">
                                    {modelCtx.modelsData[0].basicModelName}
                                </div>
                            </Grid>
                            <Grid item xs={6} sm={6} md={4} sx={{ flexGrow: 1, display: { xs: 'block', sm: 'block' }, textAlign: { xs: 'center', sm: 'right' } }}>
                                <div>
                                    <img src="images/LogoCustomLine_w.png" alt="Logo brand" className="logoBrand" />
                                </div>
                            </Grid>
                        </Grid>



                        <SwipeableDrawer
                            anchor="left"
                            open={isOpen}
                            onClose={toggleDrawer(false)}
                            onOpen={toggleDrawer(true)}
                            classes={{
                                paper: 'menu-position'
                            }}
                        >
                            {menuList()}
                        </SwipeableDrawer>

                    </Toolbar>

                </AppBar>
            }
        </>
    );
};

export default NavMenu;
